module.exports = __webpack_public_path__ + "static/media/default-avatar.711527a8.svg";